import { searchV3 as search } from 'shared/models/api';
import {
  searchOptsFromQueryParams,
  searchPageId,
  countMayChange
} from './helpers';

const SEARCH_RESULTS = 'SEARCH_RESULTS';
const SEARCH_RESULTS_LOADING = 'SEARCH_RESULTS_LOADING';

const init = {
  pageId: null,
  searchQuery: '',
  searchOpts: {},
  loadingProducts: false,
  loadingCount: false,
  products: [],
  count: 0,
  facets: []
};

export default function reducer(state = init, action = {}) {
  switch (action.type) {
    case SEARCH_RESULTS_LOADING:
      return {
        ...state,
        loadingProducts: true,
        loadingCount: action.loadingCount
      };
    case SEARCH_RESULTS:
      return {
        ...state,
        loadingProducts: false,
        loadingCount: false,
        pageId: action.pageId,
        searchQuery: action.searchQuery,
        searchOpts: action.searchOpts,
        products: action.products,
        count: action.count,
        facets: action.facets
      };
    default:
      return state;
  }
}

export function getSearchResults(searchQuery, queryParams) {
  return (dispatch, getState) => {
    const searchOpts = searchOptsFromQueryParams(queryParams);

    const prevState = getState().searchResults;
    const loadingCount = countMayChange({
      prevSearchQuery: prevState.searchQuery,
      prevSearchOpts: prevState.searchOpts,
      nextSearchQuery: searchQuery,
      nextSearchOpts: searchOpts
    });
    dispatch({ type: SEARCH_RESULTS_LOADING, loadingCount });

    return search(
      searchQuery,
      searchOpts
    ).then(({ products, count, facets }) => {
      const pageId = searchPageId(searchQuery, queryParams);
      dispatch({
        type: SEARCH_RESULTS,
        pageId,
        searchQuery,
        searchOpts,
        products,
        count,
        facets
      });
    });
  };
}
